
import { Component, Vue } from "vue-property-decorator";

@Component({ name: "icon-cart" })
export default class IconCart extends Vue {
  sData: string = require("@icon/icomoon/cart.svg");
}
